/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of PrintablesList
 * Alfapeople -Customisation object -For Print page
 */

import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
export interface IPrint {
  printHeading?: string;
  imageUrl?: string;
  textDescription?: string;
  downloadLink?: string;
}
/**
 *
 * Print component
 * @extends Component
 */
export class Print extends Component {
  private readonly printPage: IPrint = {
    printHeading: 'be a-maize-d by this popcorn holder!',
    imageUrl:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDxPh',
    textDescription:
      'This may sound a little corny, but it’s National Popcorn Day—so you butter believe we had to get involved. Download and print out this popcorn holder and give ’em a tasty treat to celebrate! Or pop some out during your next movie night for an a-maize-ing time!',
    downloadLink:
      'https://files-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/binary/MDyzL',
  };
  public render(): JSX.Element | null {
    return (
      <div className='row'>
        <div className='col-lg-12 col-md-12'>
          <h1 className='print-heading'>{this.printPage.printHeading}</h1>
        </div>
        <div className='col-lg-12 col-md-12'>
          <div className='printContainer'>
            <img
              className='img-responsive'
              src={this.printPage.imageUrl}
              alt={this.printPage.printHeading}
            />
            <p className='print-description'>
              {ReactHtmlParser(this.printPage.textDescription)}
            </p>
            <a href={this.printPage.downloadLink} className='print-download-link' target='_blank'>download
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Print;
